import { Themes, ImageThemes } from "@ebay-business-components/group-card/dist/interface";
import { ListGroupDisplayType } from "@ebay-business-components/list-group-cards/dist/interface";
$ const {
  localizedContent = {}
} = input;
<ebay-lightbox-dialog a11y-close-text="Close Dialog" open=state.open class="add-to-list-dialog" on-open('emit', "open") on-close('emit', "close")>
  <@header>
    ${localizedContent.add_to_list}
  </@header>
  <div on-click('handleOpenPromptDialog')>
    <group-card id='newlist' title=localizedContent.new_list theme=Themes.DEFAULT imageTheme=ImageThemes.ICON>
      <@icon>
        <ebay-add-16-icon/>
      </@icon>
    </group-card>
  </div>
  <list-group-cards groupCards=state.groupCards displayType=ListGroupDisplayType.VERTICAL on-click('handleAddToWatchList')>
    <@icon>
      <ebay-checkmark-24-icon/>
    </@icon>
  </list-group-cards>
</ebay-lightbox-dialog>
<if(!!state.createListOpen)>
  <prompt-dialog open=state.createListOpen title=state.promptDialog.title callToAction=state.promptDialog.callToAction inputField=state.promptDialog.inputField on-open("handleOpenPromptDialog") on-close("handleClosePromptDialog") on-confirm("handleCreateList")/>
</if>